export default __webpack_public_path__ + "static/media/scene_11.903b6b95.mp3";